<template>
    <div>

        <el-form label-position="top" v-loading="carregando">

            <el-alert v-if="semAssociacao" type="warning" :closable="false" show-icon class="u-mb-10"
                title="Seu usuário não está associado a nenhuma unidade do RH. Procure a secretaria para liberar o acesso."></el-alert>

            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Local de trabalho (instituição)">
                                <el-select v-model="filtro.instituicao_cod" multiple filterable clearable collapse-tags placeholder="Todos">
                                    <el-option v-for="i in opcoes.instituicoes" :key="i.codigo" :label="i.nome" :value="i.codigo"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Cargo / Função">
                                <el-select v-model="filtro.cargo" multiple filterable clearable collapse-tags placeholder="Todos">
                                    <el-option v-for="c in opcoes.cargos" :key="c" :label="c" :value="c"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Vínculo">
                                <el-select v-model="filtro.vinculo" multiple filterable clearable collapse-tags placeholder="Todos">
                                    <el-option v-for="v in opcoes.vinculos" :key="v" :label="v" :value="v"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Categoria">
                                <el-select v-model="filtro.categoria" multiple filterable clearable collapse-tags placeholder="Todas">
                                    <el-option v-for="c in opcoes.categorias" :key="c" :label="c" :value="c"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="8" :md="8">
                            <el-form-item label="Jornada">
                                <el-select v-model="filtro.jornada" multiple filterable clearable collapse-tags placeholder="Todas">
                                    <el-option v-for="j in opcoes.jornadas" :key="j" :label="j" :value="j"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="6">
                            <el-form-item label="Admissão a partir de">
                                <el-date-picker v-model="filtro.admissao_de" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="6">
                            <el-form-item label="Admissão até">
                                <el-date-picker v-model="filtro.admissao_ate" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Ordenar por">
                                <el-select v-model="ordenar">
                                    <el-option label="NOME" value="nome"></el-option>
                                    <el-option label="CARGO / FUNÇÃO" value="cargo"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Aposentado">
                                <el-select v-model="filtro.aposentado" clearable placeholder="Todos">
                                    <el-option label="SIM" value="sim"></el-option>
                                    <el-option label="NÃO" value="nao"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Pensionista">
                                <el-select v-model="filtro.pensionista" clearable placeholder="Todos">
                                    <el-option label="SIM" value="sim"></el-option>
                                    <el-option label="NÃO" value="nao"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Estágio probatório efetivado">
                                <el-select v-model="filtro.estagio_probatorio" clearable placeholder="Todos">
                                    <el-option label="SIM" value="sim"></el-option>
                                    <el-option label="NÃO" value="nao"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="6" :md="6">
                            <el-form-item label="Nome ou matrícula">
                                <el-input v-model="filtro.busca" clearable placeholder="Buscar..."></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>

                <el-tab-pane label="CAMPOS" name="campos">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" v-for="g in gruposCampos" :key="g.titulo">
                            <label class="u-pl-5 u-mb-5" style="display: block; font-size: 15px;"><b>{{ g.titulo }}</b></label>
                            <div style="min-height: 200px; background-color: #f8f8f8; padding:10px;">
                                <el-checkbox-group v-model="campos" class="checkbox-filtos">
                                    <el-checkbox v-for="c in g.campos" :key="c.chave" :label="c.chave">{{ c.rotulo }}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
                        <el-button @click="gerar('excel')" :loading="loadingExcel" :disabled="ocupado && !loadingExcel" type="primary">EXCEL</el-button>
                        <el-button @click="gerar('pdf')" :loading="loadingPdf" :disabled="ocupado && !loadingPdf" type="primary">PDF</el-button>
                        <el-button @click="gerar('html')" :loading="loadingHtml" :disabled="ocupado && !loadingHtml" type="primary">HTML</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-form>

    </div>
</template>
<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        carregando: false,
        loadingPdf: false,
        loadingExcel: false,
        loadingHtml: false,
        semAssociacao: false,
        opcoes: { instituicoes: [], cargos: [], vinculos: [], categorias: [], jornadas: [], colunas: [], padrao: [] },
        campos: [],
        ordenar: 'nome',
        filtro: {
            instituicao_cod: [],
            cargo: [],
            vinculo: [],
            categoria: [],
            jornada: [],
            admissao_de: '',
            admissao_ate: '',
            aposentado: '',
            pensionista: '',
            estagio_probatorio: '',
            busca: ''
        }
    }),
    computed: {
        ocupado () { return this.loadingPdf || this.loadingExcel || this.loadingHtml },
        // Campos agrupados: dados funcionais e dados de identificação/remuneração (estes só para a rede).
        gruposCampos () {
            const funcionais = ['nome', 'nr_registro', 'cargo', 'cargo_inicial', 'natureza_cargo', 'vinculo', 'categoria', 'instituicao', 'divisao', 'setor', 'unidade', 'jornada', 'data_admissao']
            const situacao = ['estagio_probatorio', 'aposentado', 'pensionista', 'cpf', 'pis', 'salario']
            const por = (lista) => lista.map(k => this.opcoes.colunas.find(c => c.chave === k)).filter(Boolean)

            return [
                { titulo: 'Dados funcionais', campos: por(funcionais) },
                { titulo: 'Situação e identificação', campos: por(situacao) }
            ]
        }
    },
    mounted () {
        this.carregarOpcoes()
    },
    methods: {
        carregarOpcoes () {
            this.carregando = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/rh-servidor/opcoes`, this.$store.getters.getHeaderAuth).then(response => {
                this.carregando = false

                // Sem acesso ao RH: volta para o relatório geral, que é o que o perfil já usava.
                if (response.data && response.data.erro) {
                    this.$emit('sem-acesso')
                    return
                }

                this.opcoes = response.data
                this.semAssociacao = !!response.data.sem_associacao
                this.campos = (response.data.padrao || []).slice()
            }).catch((error) => { this.carregando = false; this.$store.commit('throwException', error) })
        },
        payload () {
            // Campos na ordem em que aparecem nos grupos, não na ordem em que foram clicados.
            const ordem = this.opcoes.colunas.map(c => c.chave)
            return {
                colunas: ordem.filter(k => this.campos.includes(k)),
                filtros: this.filtro,
                ordenar: this.ordenar
            }
        },
        gerar (tipo) {
            if (!this.campos.length) {
                window.eventBus.$emit('alert', { msg: 'Selecione pelo menos um campo a ser apresentado no relatório.', type: 'warning' })
                this.tabAtivo = 'campos'
                return
            }

            this.carregandoTipo(tipo, true)

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/rh-servidor/${tipo}`, this.payload(), this.$store.getters.getHeaderAuthExcel).then(response => {
                this.carregandoTipo(tipo, false)

                const tipos = {
                    pdf: 'application/pdf',
                    html: 'text/html;charset=utf-8',
                    excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
                const blob = new Blob([response.data], { type: tipos[tipo] })

                // Erro de negócio no Excel volta como JSON (o tipo vem do servidor).
                if (tipo === 'excel' && response.data.type && response.data.type.indexOf('json') !== -1) {
                    new Response(response.data).text().then(t => {
                        let msg = 'Erro ao gerar o relatório.'
                        try { msg = JSON.parse(t).erro || msg } catch (e) { /* mantém a mensagem padrão */ }
                        window.eventBus.$emit('alert', { msg, type: 'warning' })
                    })
                    return
                }

                const url = window.URL.createObjectURL(blob)

                if (tipo === 'excel') {
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'servidores.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    return
                }

                const novaAba = window.open(url, '_blank')
                if (!novaAba) window.location.href = url
            }).catch((error) => {
                this.carregandoTipo(tipo, false)
                window.eventBus.$emit('alert', { msg: 'Erro ao gerar o relatório.', type: 'warning' })
                this.$store.commit('throwException', error)
            })
        },
        carregandoTipo (tipo, valor) {
            if (tipo === 'pdf') this.loadingPdf = valor
            else if (tipo === 'html') this.loadingHtml = valor
            else this.loadingExcel = valor
        }
    }
}
</script>
